export default "__VITE_ASSET__01$OxbKb__"